import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/make-legs-longer" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/make-legs-longer" element={<AsyncPage />} />
  </Route>
);
